
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as thanksU6DiKwBVnjxtMnqEa_70c8St1N6QOOgEPMHLIZhL6wEMeta } from "/app/pages/thanks.vue?macro=true";
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as _91slug_93OY1eKGH50IeGHXpXb3BdZRgtgqHXLtURcDbb48n4NVYMeta } from "/app/pages/news/[slug].vue?macro=true";
import { default as _91slug_93D_Xprynda_45zoUwWCwNil_45gqSPblAn12aq5p_dP4wcWUMeta } from "/app/pages/legal/[slug].vue?macro=true";
import { default as _91slug_93B2eBkXw00C_E8YEBPHGPIYWCO9HuzdErBSwwhlsa5QsMeta } from "/app/pages/aktsii/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93sapy7nrE0apSa6UqNG3SMoAwm2UoFuerfKSORnu9r3oMeta } from "/app/pages/cars/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93Lvf_45q7_pglfUIeoDdfWBxJFbXieG_456A_4556Xnnpclw_MMeta } from "/app/pages/buses/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93_N9ChomMkSQanHDKmzhuK209mkHEl_Bcnit6e0jl2YUMeta } from "/app/pages/used-cars/[...slug].vue?macro=true";
import { default as index7cJ_swB_bWFxdfK6w_hrBupmSwRYvqLGSZ2GZQQ9v9oMeta } from "/app/pages/prescentr/news/index.vue?macro=true";
import { default as _91_46_46_46slug_936o_Y2yhKKVIJfZGFJC28v4oWvl3JZS6weu6q8kpM2J4Meta } from "/app/pages/cars-in-stock/[...slug].vue?macro=true";
export default [
  {
    name: "index___uk",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "search___uk",
    path: "/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "thanks___uk",
    path: "/thanks",
    component: () => import("/app/pages/thanks.vue")
  },
  {
    name: "slug___uk",
    path: "/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "news-slug___uk",
    path: "/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "legal-slug___uk",
    path: "/legal/:slug()",
    component: () => import("/app/pages/legal/[slug].vue")
  },
  {
    name: "aktsii-slug___uk",
    path: "/aktsii/:slug()",
    component: () => import("/app/pages/aktsii/[slug].vue")
  },
  {
    name: "cars-slug___uk",
    path: "/cars/:slug(.*)*",
    component: () => import("/app/pages/cars/[...slug].vue")
  },
  {
    name: "buses-slug___uk",
    path: "/buses/:slug(.*)*",
    component: () => import("/app/pages/buses/[...slug].vue")
  },
  {
    name: "used-cars-slug___uk",
    path: "/used-cars/:slug(.*)*",
    component: () => import("/app/pages/used-cars/[...slug].vue")
  },
  {
    name: "prescentr-news___uk",
    path: "/prescentr/news",
    component: () => import("/app/pages/prescentr/news/index.vue")
  },
  {
    name: "cars-in-stock-slug___uk",
    path: "/cars-in-stock/:slug(.*)*",
    component: () => import("/app/pages/cars-in-stock/[...slug].vue")
  }
]